const SW_URL = `${import.meta.env.BASE_URL}firebase-messaging-sw.js`;
const SW_SCOPE = import.meta.env.BASE_URL;

/** Register the combined FCM + PWA service worker under /rider/ */
export async function registerRiderServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null;

  try {
    const existing = await navigator.serviceWorker.getRegistration(SW_SCOPE);
    const registration =
      existing ||
      (await navigator.serviceWorker.register(SW_URL, {
        scope: SW_SCOPE,
        updateViaCache: 'none',
      }));

    registration.update().catch(() => undefined);
    return registration;
  } catch (error) {
    console.warn('PWA service worker registration failed:', error);
    return null;
  }
}

export function listenForPwaInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (event) => {
    // Keep default browser install UX; stash for optional custom UI later
    (window as any).__go7DeferredInstallPrompt = event;
  });
}
